import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	ViewChild
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { SchedDiscConfigComponentBase } from "../SchedDiscConfigComponentBase";
import { NetFacadeService } from 'netview';
import { AssetPandaExport } from 'DiscoveryEngine.TS/Export';
import { AssetPandaExportConfigComponent } from '../assetpanda-export-config/assetpanda-export-config.component';

@Component({
	selector: 'sched-disc-config-assetpanda',
	templateUrl: './sched-disc-config-assetpanda.component.html',
	styleUrls: ['./sched-disc-config-assetpanda.component.scss']
})
export class SchedDiscConfigAssetPandaComponent extends SchedDiscConfigComponentBase {

	@ViewChild(AssetPandaExportConfigComponent, { static: true })
	private AssetPandaExportComp: AssetPandaExportConfigComponent;

	private static NullAssetPandaExport = new AssetPandaExport();

	public get AssetPandaExport(): AssetPandaExport {
		if (this.Discovery)
			return this.Discovery.AssetPandaExport;
		else
			return SchedDiscConfigAssetPandaComponent.NullAssetPandaExport;
	}

	constructor(private fb: UntypedFormBuilder, netFacadeService: NetFacadeService) {
		super(netFacadeService);
	}

	protected BuildForm(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.onChanges();
	}

	public get tempChanges(): boolean {
		return this.AssetPandaExportComp.tempChanges;
	}

	public get tempChangesValid(): boolean {
		return this.AssetPandaExportComp.tempChangesValid;
	}

	public applyTempChanges(): void {
		this.AssetPandaExportComp.applyTempChanges();
		this.onApplyTempChanges();
	}

	public get invalidTempChanges(): string[] {
		return this.AssetPandaExportComp.invalidTempChanges;
	}

	public discardTempChanges(): void {
		this.AssetPandaExportComp.discardTempChanges();
	}

}
